<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card p-1 pb-2">
            <div class="row">
              <div class="col-md-12" v-show="possui_fluxo">
                <div class="alert alert-warning" role="alert">
                  Atenção, não há fluxo de aprovação definido para esse centro
                  de custo!
                </div>
              </div>
              <div class="col-md-4">
                <label>Tipo de compra</label>
                <v-select v-model="dasp.purchase_type_id" :options="filteredPurchaseTypes"
                  :reduce="(purchase_types) => purchase_types.id" :label="'name'"></v-select>
              </div>
              <div :class="!rateio ? 'col-md-6' : 'd-none'">
                <label>Centro de Custo</label>
                <v-select v-model="dasp.bill_center_id" :options="billCenter" :reduce="(billCenter) => billCenter.id"
                  :label="'number_name'" @input="searchBillCenter"></v-select>
              </div>
              <div :class="rateio ? 'col-md-6' : 'd-none'">
                <label>Centro de Custo</label>
                <v-select v-model="dasp.bill_center_id" :options="billCenter" :reduce="(billCenter) => billCenter.id"
                  :label="'number_name'" multiple></v-select>
              </div>

              <div class="col-md-2">
                <br />
                <div class="custom-control custom-switch">
                  <input autocomplete="new-password" v-model="rateio" placeholder="" type="checkbox"
                    class="custom-control-input" id="customSwitch2" />
                  <label class="custom-control-label" for="customSwitch2">Rateio</label>
                </div>
              </div>
              <div class="col-md-12">
                <label>Colaborador</label>
                <v-select v-model="dasp.collaborator" :options="users" :reduce="(users) => users.id"
                  :label="'name'"></v-select>
              </div>
              <div class="col-md-4">
                <label>Destino desta aquisição</label>
                <v-select v-model="dasp.destination" :options="acquisitions" :reduce="(acquisitions) => acquisitions.id"
                  :label="'name'" class="destination-select"></v-select>
              </div>
              <!-- <div class="col-md-6">
                <label>Acordo com fornecedor</label>
                <v-select
                  v-model="dasp.agreement"
                  :options="agreement"
                  :reduce="(agreement) => agreement.id"
                  :label="'name'"
                ></v-select>
              </div> -->
              <!-- <div class="col-md-4">
                <label>Objeto da aquisição</label>
                <v-select
                  v-model="dasp.type"
                  :options="type"
                  :reduce="(type) => type.id"
                  :label="'name'"
                ></v-select>
              </div> -->
              <div class="col-md-4">
                <label>Prioridade</label>
                <v-select v-model="dasp.term" :options="priorities" :reduce="(priorities) => priorities.id"
                  :label="'name'"></v-select>
              </div>
              <div class="col-md-4">
                <label>Valor Orçado</label>
                <input type="text" class="form-control" v-model="dasp.budget" v-money="moneyConfig" disabled />
              </div>
              <hr />
              <div class="col-md-12">
                <label>Observação</label>
                <textarea class="form-control" v-model="dasp.observation" rows="3"></textarea>
              </div>
              <hr />
              <div class="col-12 mt-2">
                <h4>Detalhes do produto/serviço</h4>
              </div>
              <div class="col-md-4">
                <label>Descrição</label>
                <input type="text" class="form-control" v-model="products.description" />
              </div>
              <div class="col-md-4">
                <label>Link</label>
                <input type="text" class="form-control" v-model="products.link" />
              </div>
              <div class="col-md-2">
                <label>Valor orçado</label>
                <input type="text" class="form-control" v-money="moneyConfig" v-model="products.budget" />
              </div>
              <div class="col-md-2">
                <label>Quantidade</label>
                <input type="number" class="form-control" @keypress="onlyNumbers" min="1" v-model="products.quantity"
                  required />
              </div>
              <div class="col-md-4">
                <label>Anexo do item (opcional)</label>
                <div class="d-flex align-items-center">
                  <input type="file" class="form-control" id="productFile" accept=".pdf,.png,.jpg,.jpeg"
                    @change="validateProductFile" />
                  <button v-if="productFileName" type="button" class="close ml-2" aria-label="Limpar arquivo"
                    title="Limpar arquivo" @click="clearProductFile">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
              </div>
              <div class="col-md-2 d-flex align-items-end">
                <button class="btn btn-add" @click="add">Adicionar</button>
              </div>
              <div class="col-md-12 mt-1">
                <table class="table table-bordered" style="width: 100%">
                  <thead>
                    <tr>
                      <th scope="col" style="width: 25%">Descrição</th>
                      <th scope="col" style="width: 20%">Link</th>
                      <th scope="col" style="width: 15%">Valor Orçado</th>
                      <th scope="col" style="width: 10%">Quantidade</th>
                      <th scope="col" style="width: 20%">Anexo</th>
                      <th scope="col" style="width: 10%">Ação</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(product, index) in list" :key="index">
                      <td>{{ product.description }}</td>
                      <td style="
                          max-width: 200px;
                          white-space: nowrap;
                          overflow: hidden;
                          text-overflow: ellipsis;
                        ">
                        {{ product.link }}
                      </td>
                      <td>{{ product.budget }}</td>
                      <td>{{ product.quantity }}</td>
                      <td>
                        <div v-if="product.fileName" class="d-flex align-items-center">
                          <a href="#" @click.prevent="viewProductFile(product)" class="mr-2">{{ product.fileName }}</a>
                          <button type="button" class="close ml-auto" aria-label="Remover anexo"
                            title="Remover anexo" @click="removeProductFile(index)">
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <template v-else>-</template>
                      </td>
                      <td>
                        <button class="btn btn-crud delete" @click="remover(index)">
                          <i class="far fa-trash-alt" data-toggle="tooltip" title="Excluir"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="col-md-12 text-right">
                <hr />
                <router-link to="/dasps" class="btn btn-back mr-1">
                  <i class="fa fa-arrow-left" />
                  Voltar
                </router-link>
                <a class="btn btn-add" :style="saving ? 'pointer-events: none; opacity: 0.6;' : ''" @click="save">
                  {{ saving ? "Enviando..." : "Abrir Solicitação" }}
                  <i class="fa fa-save" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de confirmação para Aviso de Compra -->
    <div class="modal fade" id="purchaseNoticeModal" tabindex="-1" role="dialog"
      aria-labelledby="purchaseNoticeModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="purchaseNoticeModalLabel">
              <i class="fa fa-exclamation-triangle text-warning"></i>
              Confirmar Aviso de Compra
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p class="mb-3">Você tem certeza que deseja abrir essa DASP como um aviso de compra?</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
            <button type="button" class="btn btn-warning" :disabled="saving" @click="confirmPurchaseNotice">
              <i class="fa fa-check"></i>
              {{ saving ? "Enviando..." : "Confirmar" }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";

export default {
  name: "imageUpload",
  data() {
    return {
      rateio: 0,
      possui_fluxo: false,
      moneyConfig: {
        prefix: "R$ ",
        decimal: ",",
        thousands: ".",
        precision: 2,
        masked: false,
      },
      dasp: {},
      billCenter: [],
      users: [],
      acquisitions: [],
      priorities: [],
      purchase_types: [],

      products: {
        description: "",
        link: "",
        quantity: "",
        budget: "",
      },
      list: [],
      productFileName: "",
      saving: false,
      type: [
        {
          id: 1,
          name: "Serviços",
        },
        {
          id: 2,
          name: "Equipamentos e Materiais",
        },
      ],
      destination: [
        {
          id: 1,
          name: "Patrimônio IT4D",
        },
        {
          id: 2,
          name: "Para o cliente previsto no contrato de fornecimento",
        },
        {
          id: 3,
          name: "Consumo",
        },
        {
          id: 4,
          name: "Revenda",
        },
      ],
      term: [
        {
          id: 1,
          name: "Imediato",
        },
        {
          id: 2,
          name: "Muito urgente",
        },
        {
          id: 3,
          name: "Urgente",
        },
        {
          id: 4,
          name: "Não urgente",
        },
      ],
      agreement: [
        {
          id: 1,
          name: "Apenas Pedido de Compra",
        },
        {
          id: 2,
          name: "Fornecimento Recorrente",
        },
      ],
    };
  },
  computed: {
    filteredPurchaseTypes() {
      if (!this.purchase_types || !this.purchase_types.length) {
        return [];
      }

      // Se não for administrador (perfil_id == 8), filtrar avisos de compra
      if (!this.isAdmin()) {
        return this.purchase_types.filter(type =>
          !type.name.toLowerCase().includes('aviso de compra')
        );
      }

      // Se for administrador, mostrar todos os tipos
      return this.purchase_types;
    }
  },
  methods: {

    onlyNumbers(event) {
      const char = String.fromCharCode(event.keyCode);
      if (!/[0-9]/.test(char)) {
        event.preventDefault();
      }
    },
    makeFormData: function () {
      const self = this;
      let fd = new FormData();

      fd.append("term", self.dasp.term ? self.dasp.term : "");
      fd.append(
        "observation",
        self.dasp.observation ? self.dasp.observation : ""
      );
      fd.append(
        "purchase_type_id",
        self.dasp.purchase_type_id ? self.dasp.purchase_type_id : ""
      );
      fd.append(
        "bill_center_id",
        self.dasp.bill_center_id ? self.dasp.bill_center_id : ""
      );
      fd.append(
        "destination",
        self.dasp.destination ? self.dasp.destination : ""
      );
      fd.append("agreement", self.dasp.agreement ? self.dasp.agreement : "");
      fd.append(
        "collaborator",
        self.dasp.collaborator ? self.dasp.collaborator : ""
      );
      const serializableList = self.list.map(({ file, ...item }) => item);
      fd.append("list", JSON.stringify(serializableList));

      return fd;
    },
    save: function () {
      const self = this;

      // Validações básicas
      if (!self.validateFields()) {
        return;
      }

      // Se é aviso de compra, mostrar modal de confirmação
      if (self.isPurchaseNotice()) {
        $('#purchaseNoticeModal').modal('show');
        return;
      }

      // Continuar com salvamento normal
      self.performSave();
    },
    validateFields: function () {
      const self = this;

      // Validações dos campos obrigatórios com mensagens específicas
      if (!self.dasp.purchase_type_id || self.dasp.purchase_type_id === "" || self.dasp.purchase_type_id === null || self.dasp.purchase_type_id === undefined) {
        this.$message(null, "O campo 'Tipo de compra' é obrigatório", "error");
        return false;
      }

      if (!self.dasp.bill_center_id || self.dasp.bill_center_id === "" || self.dasp.bill_center_id === null || self.dasp.bill_center_id === undefined) {
        this.$message(null, "O campo 'Centro de Custo' é obrigatório", "error");
        return false;
      }

      if (!self.dasp.collaborator || self.dasp.collaborator === "" || self.dasp.collaborator === null || self.dasp.collaborator === undefined) {
        this.$message(null, "O campo 'Colaborador' é obrigatório", "error");
        return false;
      }

      if (!self.dasp.destination || self.dasp.destination === "" || self.dasp.destination === null || self.dasp.destination === undefined) {
        this.$message(null, "O campo 'Destino desta aquisição' é obrigatório", "error");
        return false;
      }

      if (!self.dasp.term || self.dasp.term === "" || self.dasp.term === null || self.dasp.term === undefined) {
        this.$message(null, "O campo 'Prioridade' é obrigatório", "error");
        return false;
      }

      if (!self.list.length) {
        this.$message(
          null,
          "Você precisa adicionar pelo menos um produto/serviço",
          "error"
        );
        return false;
      }

      // Validar se há produtos com quantidade ou valor orçado inválidos
      const invalidProducts = self.list.filter(product => {
        const quantity = Number(product.quantity) || 0;
        const budgetValue = String(product.budget || "")
          .replace(/[R$\s]/g, "")
          .replace(/\./g, "")
          .replace(",", ".");
        const budgetNumber = parseFloat(budgetValue) || 0;

        return quantity <= 0 || budgetNumber <= 0;
      });

      if (invalidProducts.length > 0) {
        this.$message(
          null,
          "Existem produtos com quantidade ou valor orçado igual a zero. Por favor, corrija antes de salvar.",
          "error"
        );
        return false;
      }

      // Verificar se todos os itens têm quantidade maior que zero
      const itemSemQuantidade = self.list.find(item => {
        const quantidade = Number(item.quantity) || 0;
        return quantidade <= 0;
      });

      if (itemSemQuantidade) {
        this.$message(
          null,
          "Todos os itens devem ter quantidade maior que 0",
          "error"
        );
        return false;
      }

      return true;
    },
    isPurchaseNotice: function () {
      const self = this;
      if (!self.dasp.purchase_type_id || !self.purchase_types.length) {
        return false;
      }

      const selectedType = self.purchase_types.find(type => type.id === self.dasp.purchase_type_id);
      return selectedType && selectedType.name.toLowerCase().includes('aviso de compra');
    },
    isAdmin: function () {
      return this.$store.state.user && this.$store.state.user.perfil_id === 8;
    },
    performSave: function (isPurchaseNotice = false) {
      const self = this;

      if (self.saving) {
        return;
      }

      self.saving = true;

      let api = self.$store.state.api + "dasps";

      let fd = self.makeFormData();

      // Se é aviso de compra, adicionar flag
      if (isPurchaseNotice) {
        fd.append("is_purchase_notice", "true");
      }

      axios
        .post(api, fd)
        .then((response) => {
          const message = isPurchaseNotice
            ? "Aviso de compra criado com sucesso (aprovado e finalizado)"
            : "Informações guardadas com sucesso";

          const daspId = response.data.dasp_id;
          const productIds = response.data.product_ids;

          const afterSave = () => {
            self.$message("Sucesso", message, "success");
            self.$router.push("/dasps");
          };

          const hasPendingUploads = self.list.some((product) => product.file);

          if (daspId && hasPendingUploads) {
            self
              .uploadProductDocs(daspId, productIds)
              .then(afterSave)
              .catch(() => {
                self.$message(
                  "Atenção",
                  "DASP criada, mas houve falha ao enviar algum arquivo",
                  "warning"
                );
                self.$router.push("/dasps");
              });
          } else {
            afterSave();
          }
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
          self.saving = false;
        });
    },
    confirmPurchaseNotice: function () {
      // Fechar o modal
      $('#purchaseNoticeModal').modal('hide');

      // Executar salvamento como aviso de compra
      this.performSave(true);
    },
    getDasp: function (id) {
      const self = this;
      const api = self.$store.state.api + "dasps/" + id;

      axios
        .get(api)
        .then((response) => {
          self.dasp = response.data.data[0];
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getBillCenter: function () {
      const self = this;
      const api = self.$store.state.api + "bill_centers?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.billCenter = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },

    getPurchaseTypes: function () {
      const self = this;
      const api = self.$store.state.api + "purchase_types?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.purchase_types = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },

    getAcquisitions: function () {
      const self = this;
      const api = self.$store.state.api + "acquisitions?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.acquisitions = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },

    getPriorities: function () {
      const self = this;
      const api = self.$store.state.api + "priorities?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.priorities = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },

    getUsers: function () {
      const self = this;
      const api = self.$store.state.api + "users_solicitation?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.users = response.data.users;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    formatarData(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    add() {
      if (this.products.description === "") {
        this.$message(null, "Você precisa informar a descrição", "error");
        return;
      }

      // Validação mais robusta para quantidade
      if (this.products.quantity === "" || this.products.quantity === null || this.products.quantity === undefined) {
        this.$message(null, "Você precisa informar a quantidade", "error");
        return;
      }

      // Validação para não permitir quantidade 0 ou negativa
      const quantityValue = Number(this.products.quantity);
      if (isNaN(quantityValue) || quantityValue <= 0) {
        this.$message(null, "A quantidade deve ser maior que zero", "error");
        return;
      }

      // Validação para não permitir valor orçado 0
      const budgetValue = String(this.products.budget || "")
        .replace(/[R$\s]/g, "")
        .replace(/\./g, "")
        .replace(",", ".");
      const budgetNumber = parseFloat(budgetValue);

      if (!this.products.budget || isNaN(budgetNumber) || budgetNumber <= 0) {
        this.$message(null, "O valor orçado deve ser maior que zero", "error");
        return;
      }

      if (
        this.products.link !== "" &&
        !["http://", "https:/"].includes(this.products.link.substring(0, 7))
      ) {
        this.$message(
          null,
          "Por favor, insira um link válido (http, ou https)",
          "error"
        );
        return;
      }

      const productFileInput = document.getElementById("productFile");
      const productFile = productFileInput.files[0];

      if (productFile && !this.isFileValid(productFile)) {
        return;
      }

      const newEntry = {
        description: this.products.description,
        link: this.products.link,
        quantity: this.products.quantity,
        budget: this.products.budget,
        file: productFile || null,
        fileName: productFile ? productFile.name : "",
      };

      this.list.push(newEntry);

      this.products.description = "";
      this.products.link = "";
      this.products.quantity = "";
      this.products.budget = "";
      productFileInput.value = "";
      this.productFileName = "";

      this.changeBudget();
    },
    validateProductFile() {
      const fileInput = document.getElementById("productFile");
      const file = fileInput.files[0];

      if (!file) {
        this.productFileName = "";
        return;
      }

      if (!this.isFileValid(file)) {
        fileInput.value = "";
        this.productFileName = "";
        return;
      }

      this.productFileName = file.name;
    },
    clearProductFile() {
      document.getElementById("productFile").value = "";
      this.productFileName = "";
    },
    remover(index) {
      const self = this;
      self.list.splice(index, 1);

      this.changeBudget();
    },
    viewProductFile(product) {
      window.open(URL.createObjectURL(product.file), "_blank");
    },
    removeProductFile(index) {
      this.list[index].file = null;
      this.list[index].fileName = "";
    },
    isFileValid: function (file) {
      const allowedTypes = [
        "application/pdf",
        "image/png",
        "image/jpeg",
        "image/jpg",
      ];
      const allowedExtensions = [".pdf", ".png", ".jpg", ".jpeg"];

      const fileExtension = file.name
        .toLowerCase()
        .substring(file.name.lastIndexOf("."));

      if (
        !allowedTypes.includes(file.type) &&
        !allowedExtensions.includes(fileExtension)
      ) {
        this.$message(
          null,
          "Tipo de arquivo não suportado. Use apenas: PDF, PNG, JPG ou JPEG",
          "error"
        );
        return false;
      }

      const maxSize = 10 * 1024 * 1024;
      if (file.size > maxSize) {
        this.$message(
          null,
          "Arquivo muito grande. O tamanho máximo é 10MB",
          "error"
        );
        return false;
      }

      return true;
    },
    uploadProductDocs(daspId, productIds) {
      const self = this;
      let api = self.$store.state.api + "dasp_docs";

      const uploads = [];

      self.list.forEach((product, index) => {
        if (product.file && productIds && productIds[index]) {
          let fd = new FormData();
          fd.append("description", product.description);
          fd.append("dasp_id", daspId);
          fd.append("dasp_product_id", productIds[index]);
          fd.append("user_id", self.$store.state.user.id);
          fd.append("file", product.file);

          uploads.push(axios.post(api, fd));
        }
      });

      return Promise.all(uploads);
    },
    changeBudget() {
      const self = this;

      self.dasp.budget = 0;

      self.list.forEach((product) => {
        const unit = parseFloat(
          String(product.budget || "")
            .slice(3)                 // remove "R$ "
            .replace(/\./g, "")
            .replace(/,/g, ".")
        ) || 0;

        // use a quantidade (padrão = 1)
        const qty = Number(product.quantity) || 1;

        self.dasp.budget += unit;
      });

      // mantém seu arredondamento atual
      self.dasp.budget = Math.round(self.dasp.budget * 10000) / 100;
    },
    searchBillCenter() {
      const self = this;
      let api =
        self.$store.state.api +
        `bill_center_flows?bill_center_id=${self.dasp.bill_center_id}`;
      self.$loading(true);

      axios
        .get(api)
        .then((response) => {
          self.possui_fluxo = response.data.data.length === 0 ? true : false;

          self.$loading(false);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;
    let id = self.$route.params.id;

    self.getBillCenter();
    self.getUsers();
    self.getPurchaseTypes();
    self.getAcquisitions();
    self.getPriorities();

    if (id) {
      self.getDasp(id);
    }
  },
  components: {
    BaseCrud,
    vSelect,
  },
};
</script>
<style scoped>
.profile_user {
  text-align: center;
}

.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}

.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important;
}

.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}

.destination-select>>>.vs__dropdown-menu {
  width: auto !important;
  min-width: 100% !important;
  max-width: 500px !important;
  white-space: normal !important;
  overflow-x: visible !important;
  z-index: 9999 !important;
}

.destination-select>>>.vs__dropdown-option {
  white-space: normal !important;
  word-wrap: break-word !important;
  padding: 8px 12px !important;
  line-height: 1.4 !important;
  max-width: none !important;
}

.destination-select>>>.vs__selected {
  white-space: normal !important;
  overflow: visible !important;
  text-overflow: clip !important;
}

.destination-select>>>.vs__search {
  width: 100% !important;
}
</style>